import { Card, CardBody, Col } from "reactstrap";
import Swal from "sweetalert2";
import { Btn } from "../../../AbstractElements";
import { AnimatedAlertTitle, ClickIt } from "../../../Constants/Constants";
import { AnimatedAlertSunTitle } from "../../../Data/BonusUi/SweetAlert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const AnimatedAlert = () => {
  const handleAlert = () => {
    Swal.fire({
      title: "Custom animation with Animate.css",
      showClass: {
        popup: `
                animate__animated
                animate__fadeInUp
                animate__faster
              `,
      },
      hideClass: {
        popup: `
                animate__animated
                animate__fadeOutDown
                animate__faster
              `,
      },
    });
  };
  return (
    <Col xxl="3" xl="4" sm="6" xs="12" className="box-col-4">
      <Card className="height-equal">
        <CommonCardHeader title={AnimatedAlertTitle} span={AnimatedAlertSunTitle} />
        <CardBody className="btn-showcase">
          <Btn color="primary" className="m-0" onClick={handleAlert}>
            {ClickIt}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AnimatedAlert;
